(() => {
 function init(root=document){
  root.querySelectorAll('[data-jp-mobile-menu]').forEach(dialog=>{
   if(dialog.dataset.ready)return;dialog.dataset.ready='true';
   const button=document.querySelector('[aria-controls="'+dialog.id+'"]');
   if(!button)return;
   button.addEventListener('click',()=>{dialog.showModal();button.setAttribute('aria-expanded','true');});
   dialog.querySelector('[data-jp-mobile-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('close',()=>{button.setAttribute('aria-expanded','false');button.focus();});
   dialog.addEventListener('click',event=>{
    if(event.target.closest('a')){dialog.close();return;}
    if(event.target!==dialog)return;
    const rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
   });
   const media=matchMedia('(min-width:750px)');media.addEventListener('change',()=>{if(media.matches&&dialog.open)dialog.close();});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
